'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        fileBrowserFileTypes: {
            type: String,
            kComposite: 'fileBrowser.fileTypes'
        },
        fileBrowserPath: {
            type: String,
            kComposite: 'fileBrowser.path'
        },
        fileBrowserTransportRead: {
            type: String | Function,
            kComposite: 'fileBrowser.transport.read'
        },
        fileBrowserTransportReadContentType: {
            type: String,
            kComposite: 'fileBrowser.transport.read.contentType'
        },
        fileBrowserTransportReadData: {
            type: Object | String | Function,
            kComposite: 'fileBrowser.transport.read.data'
        },
        fileBrowserTransportReadDataType: {
            type: String,
            kComposite: 'fileBrowser.transport.read.dataType'
        },
        fileBrowserTransportReadType: {
            type: String,
            kComposite: 'fileBrowser.transport.read.type'
        },
        fileBrowserTransportReadUrl: {
            type: String | Function,
            kComposite: 'fileBrowser.transport.read.url'
        },
        fileBrowserTransportUploadUrl: {
            type: String,
            kComposite: 'fileBrowser.transport.uploadUrl'
        },
        fileBrowserTransportFileUrl: {
            type: String | Function,
            kComposite: 'fileBrowser.transport.fileUrl'
        },
        fileBrowserTransportDestroy: {
            type: String,
            kComposite: 'fileBrowser.transport.destroy'
        },
        fileBrowserTransportDestroyContentType: {
            type: String,
            kComposite: 'fileBrowser.transport.destroy.contentType'
        },
        fileBrowserTransportDestroyData: {
            type: Object | String | Function,
            kComposite: 'fileBrowser.transport.destroy.data'
        },
        fileBrowserTransportDestroyDataType: {
            type: String,
            kComposite: 'fileBrowser.transport.destroy.dataType'
        },
        fileBrowserTransportDestroyType: {
            type: String,
            kComposite: 'fileBrowser.transport.destroy.type'
        },
        fileBrowserTransportDestroyUrl: {
            type: String | Function,
            kComposite: 'fileBrowser.transport.destroy.url'
        },
        fileBrowserTransportCreate: {
            type: String,
            kComposite: 'fileBrowser.transport.create'
        },
        fileBrowserTransportCreateContentType: {
            type: String,
            kComposite: 'fileBrowser.transport.create.contentType'
        },
        fileBrowserTransportCreateData: {
            type: Object | String | Function,
            kComposite: 'fileBrowser.transport.create.data'
        },
        fileBrowserTransportCreateDataType: {
            type: String,
            kComposite: 'fileBrowser.transport.create.dataType'
        },
        fileBrowserTransportCreateType: {
            type: String,
            kComposite: 'fileBrowser.transport.create.type'
        },
        fileBrowserTransportCreateUrl: {
            type: String | Function,
            kComposite: 'fileBrowser.transport.create.url'
        },
        fileBrowserSchemaModelId: {
            type: String,
            kComposite: 'fileBrowser.schema.model.id'
        },
        fileBrowserSchemaModelFieldsName: {
            type: String,
            kComposite: 'fileBrowser.schema.model.fields.name'
        },
        fileBrowserSchemaModelFieldsNameField: {
            type: String,
            kComposite: 'fileBrowser.schema.model.fields.name.field'
        },
        fileBrowserSchemaModelFieldsNameParse: {
            type: Function,
            kComposite: 'fileBrowser.schema.model.fields.name.parse'
        },
        fileBrowserSchemaModelFieldsType: {
            type: String,
            kComposite: 'fileBrowser.schema.model.fields.type'
        },
        fileBrowserSchemaModelFieldsTypeParse: {
            type: Function,
            kComposite: 'fileBrowser.schema.model.fields.type.parse'
        },
        fileBrowserSchemaModelFieldsTypeField: {
            type: String,
            kComposite: 'fileBrowser.schema.model.fields.type.field'
        },
        fileBrowserSchemaModelFieldsSize: {
            type: String,
            kComposite: 'fileBrowser.schema.model.fields.size'
        },
        fileBrowserSchemaModelFieldsSizeField: {
            type: String,
            kComposite: 'fileBrowser.schema.model.fields.size.field'
        },
        fileBrowserSchemaModelFieldsSizeParse: {
            type: Function,
            kComposite: 'fileBrowser.schema.model.fields.size.parse'
        },
        fileBrowserMessagesUploadFile: {
            type: String,
            kComposite: 'fileBrowser.messages.uploadFile'
        },
        fileBrowserMessagesOrderBy: {
            type: String,
            kComposite: 'fileBrowser.messages.orderBy'
        },
        fileBrowserMessagesOrderByName: {
            type: String,
            kComposite: 'fileBrowser.messages.orderByName'
        },
        fileBrowserMessagesOrderBySize: {
            type: String,
            kComposite: 'fileBrowser.messages.orderBySize'
        },
        fileBrowserMessagesDirectoryNotFound: {
            type: String,
            kComposite: 'fileBrowser.messages.directoryNotFound'
        },
        fileBrowserMessagesEmptyFolder: {
            type: String,
            kComposite: 'fileBrowser.messages.emptyFolder'
        },
        fileBrowserMessagesDeleteFile: {
            type: String,
            kComposite: 'fileBrowser.messages.deleteFile'
        },
        fileBrowserMessagesInvalidFileType: {
            type: String,
            kComposite: 'fileBrowser.messages.invalidFileType'
        },
        fileBrowserMessagesOverwriteFile: {
            type: String,
            kComposite: 'fileBrowser.messages.overwriteFile'
        },
        fileBrowserMessagesSearch: {
            type: String,
            kComposite: 'fileBrowser.messages.search'
        }
    }
};